<template>
  <div></div>
</template>

<script>
  import gql from 'graphql-tag';

  export default {
    data() {
      return {
        xvue: null,
      };
    },
    watch: {
      '$store.state.CARGO.sede': function() {
        this.listarprogramasgraphql(this.xvue);
      },
    },
    components: {},
    methods: {
      async listarprogramasgraphql(vue) {
        this.xvue = vue;
        vue.programas = [];
        vue.isloadingprograma = true;
        let idsede = this.$store.state.CARGO.sede.id;
        //let gestion = new Date().getFullYear();
        var sql = gql`query{ getProgramas(cursor:1000000,estado:true,idsede:${idsede}){ id,plataforma_id, course_category_id,fase,version,grupo,estado,codigo,nombre_compuesto} }`;
        await this.$apollo
          .query({ query: sql, variables: { cursor: this.cursor } })
          .then(({ data }) => {
            let datos = data.getProgramas;
            //window.console.log(datos);
            datos.forEach((x, indice) => {
              if (!x.codigo) x.text = `${indice + 1}.- ${x.nombre_compuesto}`;
              else x.text = `${indice + 1}.- ${x.nombre_compuesto} [${x.codigo}]`;
              x.value = x.id;
              vue.programas.push(x);
            });
            vue.isloadingprograma = false;
            this.$emit('onloadprogramas');
          })
          .catch(() => {
            this.$emit('onloadprogramas');
            vue.isloadingprograma = false;
          });
      },
    },
    mounted() {},
  };
</script>
